import { useContext } from 'react';
import { AccountType } from '../__generated__/pge-types';
import useGetAccountType from './useGetAccountType';
import { featureFlagsContext } from '../providers/FeatureFlagsProvider';

export function useAccountCustomerDashboard() {
  const {
    isNewAccountDashboardEnabled,
    loading: featureFlagLoading,
  } = useContext(featureFlagsContext);
  const { accountTypeData, loading: accountTypeLoading } = useGetAccountType(
    {},
  );
  const accountType =
    accountTypeData &&
    accountTypeData.getAccountDetails &&
    accountTypeData?.getAccountDetails[0]?.accountType;
  const isResAccount = accountType === AccountType?.Res;
  /**
   * If the user is a residential account and the new account dashboard feature flag is enabled, display the new UI
   */
  const loading = featureFlagLoading || accountTypeLoading;
  const showLegacyUI = !(isNewAccountDashboardEnabled && isResAccount);
  return {
    showLegacyUI,
    isResAccount,
    loading,
  };
}
